import { Typography, Grid } from '@mui/material'
import React from 'react'
import Chart from 'react-apexcharts'

interface SpeedMeterChartProps {
  data: number
  width?: string
  startAngle?: number
  endAngle?: number
  height?: string
  fontSizeLabel?: string
  fontSizeValue?: string
  heightChart?: string
  alignZeroPercent: string
  alignHundredPercent: string
  comply: number | string
  noComply: number | string
}

export const SpeedMeterChart: React.FC<SpeedMeterChartProps> = ({
  width,
  data,
  startAngle = 0,
  endAngle = 0,
  height,
  fontSizeLabel,
  fontSizeValue,
  heightChart,
  alignZeroPercent,
  alignHundredPercent,
  comply,
  noComply
}) => {
  const configuration = {
    options: {
      chart: {
        height: 280
      },
      plotOptions: {
        radialBar: {
          dataLabels: {
            show: true,
            name: {
              show: true,
              fontSize: `${fontSizeLabel}`,
              fontFamily: 'Poppins,sans-serif',
              fontWeight: 600,
              color: '#373d3f',
              offsetY: 20
            },
            value: {
              show: true,
              fontSize: `${fontSizeValue}`,
              fontFamily: 'Poppins,sans-serif',
              fontWeight: 400,
              color: '#373d3f',
              offsetY: -30
            }
          },
          startAngle: startAngle,
          endAngle: endAngle,
          track: {
            background: '#BFC0BF',
            startAngle: startAngle,
            endAngle: endAngle
          }
        }
      },
      fill: {
        type: 'gradient',
        gradient: {
          shade: 'dark',
          type: 'horizontal',
          gradientToColors: ['#FC4040'],
          colorStops: [
            {
              offset: 0,
              color: '#004BB1',
              opacity: 1
            },
            {
              offset: 10,
              color: '#004BB1',
              opacity: 1
            },
            {
              offset: 20,
              color: '#2B82F4',
              opacity: 1
            },
            {
              offset: 30,
              color: '#408ef5',
              opacity: 1
            },
            {
              offset: 40,
              color: '#559bf6',
              opacity: 1
            },
            {
              offset: 50,
              color: '#6aa7f7',
              opacity: 1
            },

            {
              offset: 60,
              color: '#7fb4f8',
              opacity: 1
            },
            {
              offset: 70,
              color: '#95c0f9',
              opacity: 1
            },
            {
              offset: 80,
              color: '#559bf6',
              opacity: 1
            },
            {
              offset: 90,
              color: '#fc6666',
              opacity: 1
            },
            {
              offset: 92,
              color: '#fc6666',
              opacity: 1
            },
            {
              offset: 94,
              color: '#fc6666',
              opacity: 1
            },
            {
              offset: 96,
              color: '#fc6666',
              opacity: 1
            },
            {
              offset: 98,
              color: '#fc5353',
              opacity: 1
            },
            {
              offset: 100,
              color: '#FC4040',
              opacity: 1
            }
          ],
          stops: [0, 10, 20, 30, 40, 50, 60, 70, 80, 90, 100]
        }
      },
      labels: ['Fillrate']
    },
    stroke: {
      lineCap: 'butt'
    },

    series: [data]
  }

  return (
    <div className='app' style={{ minHeight: `${heightChart}px` }}>
      <div className='row'>
        <div className='mixed-chart' style={{ height: `${heightChart}px` }}>
          <Chart
            options={configuration.options}
            series={configuration.series}
            type='radialBar'
            width={width}
            height={height}
          />
        </div>
      </div>
      <Typography
        variant='body2'
        color='textSecondary'
        component='p'
        style={{ margin: alignZeroPercent }}
      >
        {'0%'}
      </Typography>
      <Typography
        variant='body2'
        color='textSecondary'
        component='p'
        style={{ margin: alignHundredPercent }}
      >
        {'100%'}
      </Typography>
      <Grid container style={{ marginTop: '20px' }}>
        <Grid item xs={3}></Grid>
        <Grid item xs={4}>
          <Typography variant='body2' color='textSecondary' component='p'>
            Cumple
          </Typography>
        </Grid>
        <Grid item xs={1}>
          <Typography variant='body2' color='textSecondary' component='p'>
            {`${comply}`}
          </Typography>
        </Grid>
        <Grid item xs={4}></Grid>
      </Grid>
      <Grid container>
        <Grid item xs={4}></Grid>
        <Grid item xs={4}>
          <hr></hr>
        </Grid>
        <Grid item xs={1}></Grid>
        <Grid item xs={4}></Grid>
      </Grid>

      <Grid container>
        <Grid item xs={3}></Grid>
        <Grid item xs={4}>
          <Typography variant='body2' color='textSecondary' component='p'>
            No Cumple
          </Typography>
        </Grid>
        <Grid item xs={1}>
          <Typography variant='body2' color='textSecondary' component='p'>
            {`${noComply}`}
          </Typography>
        </Grid>
        <Grid item xs={4}></Grid>
      </Grid>
    </div>
  )
}
